module.exports = __webpack_public_path__ + "static/media/S1-36-Explosão Goldroniana-cod71.b95e494b.png";